import { WidgetDto } from "@intelligems/ig-types";
import { PayloadAction } from "@reduxjs/toolkit";
import { AppListenerMiddleware } from "@src/store";
import {
  createUserInterfaceWidget,
  updateUserInterface,
} from "@src/store/slices/userInterfaces/index";
import { closeWidget, createWidget } from "@src/store/slices/widgets";

export function setupUserInterfaceListener(middleware: AppListenerMiddleware) {
  middleware.startListening({
    actionCreator: createUserInterfaceWidget,
    effect: async (action, { dispatch, take }) => {
      dispatch(createWidget(action.payload.type));
      const takeResult = await take(
        (action) => action.type === closeWidget.type
      );
      const closeWidgetAction = takeResult[0] as PayloadAction<
        WidgetDto | undefined
      >;
      if (closeWidgetAction.payload) {
        dispatch(
          updateUserInterface({
            id: action.payload.id,
            widget: closeWidgetAction.payload,
          })
        );
      }
    },
  });
}
